import { Trans } from '@lingui/macro'
import { HelpOutline } from '@mui/icons-material'
import {
  IconButton,
  Tooltip
} from '@mui/material'
import Inquiry from 'app/EgretLayout/SharedCompoents/Inquiry'
import { FundToCaseType } from 'app/services/sfAuth/sfData/sfOpportunity'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  HELP_CASE_TYPES
} from '../../../services/sfAuth/sfData/sfCase'

function ContactProgramManager ({
  recordType,
  active,
  opportunityId,
  prequalificationId,
  fundingStreamId
}) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const fundingStreams = useSelector(state => state.fundingStreams.streams)
  const [streamCaseType, setStreamCaseType] = React.useState(null)

  useEffect(() => {
    if (fundingStreams) {
      const matchingFundingStream = fundingStreams.find(
        stream => stream.id === fundingStreamId
      )
      if (matchingFundingStream && matchingFundingStream.caseType) {
        setStreamCaseType(matchingFundingStream.caseType)
      }
    }
  }, [fundingStreams, opportunityId])

  return (
    <>
      <Inquiry
        // selectCaseLocation
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        caseType={streamCaseType ||
              FundToCaseType[recordType] ||
              HELP_CASE_TYPES.FUNDING_UNSURE}
        additionalValues={{
          skipAssigment: true,
          opportunityId,
          prequalificationId
        }}
        translations={{
          titleTranslation: <Trans>Contact Program Manager</Trans>,
          topTranslations: '',
          subjectFieldLabel: <Trans>Subject</Trans>,
          describeTranslation: <Trans>CONTACT_PM_GRANT_DESCRIPTION</Trans>
        }}
      />
      <Tooltip
        title={
        active
          ? (
            <Trans>Contact Program Manager</Trans>
            )
          : (
            <Trans>Your opportunity has no Programe assigne yet</Trans>
            )
      }
      >
        <IconButton
          style={{ color: !active && '#BDBDBD' }}
          onClick={() => {
            if (!active) {
              return
            }
            setDialogOpen(true)
          }}
          size='large'
        >
          <HelpOutline />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default ContactProgramManager
